import React from 'react';
import { canadianCities } from '../../data/locations';
import { industries } from '../../data/industries';
// Import the actual components
import LocationPage from './LocationPage';
import IndustryPage from './IndustryPage';

export default function TestActualComponents() {
  const toronto = canadianCities.find(c => c.slug === 'toronto');
  const medical = industries.find(i => i.slug === 'medical-professionals');
  
  return (
    <div>
      <div style={{ padding: '20px', background: '#f0f0f0' }}>
        <h2>Testing Actual Components</h2>
        <p>Toronto data exists: {toronto ? 'YES' : 'NO'}</p>
        <p>Medical data exists: {medical ? 'YES' : 'NO'}</p>
      </div>
      
      <div style={{ border: '2px solid red', margin: '20px' }}>
        <h3>Location Page Component:</h3>
        {toronto && <LocationPage city={toronto} />}
      </div>
      
      <div style={{ border: '2px solid blue', margin: '20px' }}>
        <h3>Industry Page Component:</h3>
        {medical && <IndustryPage industry={medical} />}
      </div>
    </div>
  );
}